import { render, staticRenderFns } from "./Spotlight.vue?vue&type=template&id=6171d37c&scoped=true&"
import script from "./Spotlight.vue?vue&type=script&lang=js&"
export * from "./Spotlight.vue?vue&type=script&lang=js&"
import style0 from "./Spotlight.vue?vue&type=style&index=0&id=6171d37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171d37c",
  null
  
)

export default component.exports